"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InterceptorsManager = void 0;
class InterceptorsManager {
    constructor(axiosInstance, clientConfig) {
        this.axiosInstance = axiosInstance;
        this.clientConfig = clientConfig;
    }
    setupInterceptors(interceptors = []) {
        interceptors.reverse().forEach(InterceptorClass => {
            const interceptor = new InterceptorClass(this.clientConfig, this.axiosInstance);
            if (interceptor.registerWhen && !interceptor.registerWhen(this.clientConfig)) {
                return;
            }
            if (interceptor.onRequest) {
                this.axiosInstance.interceptors.request.use(interceptor.onRequest, undefined, {
                    runWhen: interceptor.runWhen
                });
            }
            if (interceptor.onResponse || interceptor.onError) {
                this.axiosInstance.interceptors.response.use(interceptor.onResponse, interceptor.onError);
            }
        });
    }
}
exports.InterceptorsManager = InterceptorsManager;
